/* registerSW.js
   Call once from main.jsx (or top of App.jsx) to register the service worker.
   Safe to call in development — only registers in production.
*/

export function registerServiceWorker() {
  // Only register in production and in browsers that support SW
  if (import.meta.env.PROD && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js', { scope: '/' })
        .then((registration) => {
          console.log('[PWA] Service worker registered:', registration.scope);

          // Check for updates every time the app loads
          registration.update();

          // Notify user if a new version is available (optional — silent for now)
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (!newWorker) return;
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New content available — could show a toast here if desired
                console.log('[PWA] New version available — will activate on next visit');
              }
            });
          });
        })
        .catch((err) => {
          // Non-fatal — app still works without SW
          console.warn('[PWA] Service worker registration failed:', err);
        });
    });
  }
}
